import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { announcementService } from '../../service/announcement.service';
@Component({
  selector: 'app-announcementlist',
  templateUrl: './announcementlist.component.html',
  styleUrls: ['./announcementlist.component.css'],
  providers:[announcementService]
})
export class AnnouncementlistComponent implements OnInit {
  announcement:any=[];
  announcementCount:any=0;
  msg="";
  constructor(private announcementobj : announcementService) { 

  }
  
  ngOnInit() {
    this.getannouncementCount();
    var obj={}
    obj['limit']=10;  
    obj['orderby']="id";
    obj['ordertype']="desc";
    this.getannouncement(obj);
  }

  getannouncement(obj){
    
    this.announcementobj.getannouncement(obj).subscribe((data:any)=>{
     if(data.error==0){
      Array.prototype.push.apply(this.announcement,data.data); 
    //  this.announcement.concat(data.data);
     }

    },(error : HttpErrorResponse)=>{      
      this.msg="internal server error!";
    });
  }

  getannouncementCount(){
    var obj={}   
    this.announcementobj.getannouncementCount(obj).subscribe((data:any)=>{
     if(data.error==0){
       //console.log("count");
       //console.log(data);
     
       this.announcementCount=data.data;
     }

    },(error : HttpErrorResponse)=>{      
      this.msg="internal server error!";
    });
  }

  loadmore(){
    var obj={}
    obj['limit']=10;  
    obj['orderby']="id";
    obj['ordertype']="desc";
    obj['offset']=this.announcement.length;
    this.getannouncement(obj);

  }
}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/announcementlist/announcementlist.component.ts